import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";

var TokenProvider = /*#__PURE__*/function () {
  function TokenProvider() {
    _classCallCheck(this, TokenProvider);
  }

  _createClass(TokenProvider, [{
    key: "getAuthorizationToken",
    value: async function getAuthorizationToken() {
      var token = null;
      token = await this.getTokenServicePublicToken();

      if (!token) {
        throw new Error('Missing access token');
      }

      return token;
    } // eslint-disable-next-line class-methods-use-this -- `this` is not needed here.

  }, {
    key: "getTokenServicePublicToken",
    value: async function getTokenServicePublicToken() {
      var _window$ori;

      if ((_window$ori = window.ori) !== null && _window$ori !== void 0 && _window$ori.tokenService) {
        try {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- from template
          var oriToken = await window.ori.tokenService.getPublicToken();

          if (oriToken) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-member-access -- from template
            return oriToken.Token;
          }
        } catch (error) {
          console.warn(error);
        }
      }

      return null;
    }
  }]);

  return TokenProvider;
}();

var tokenProvider = new TokenProvider();
export { tokenProvider as TokenProvider };